module.exports = __webpack_public_path__ + "img/btn-nebulae.923eae18.svg";